import StateBoot from 'app/states/Boot';
import StateLoad from 'app/states/Load';
import StateWelcome from 'app/states/Welcome';
import StateCampout from 'app/states/Campout';

export const STATE_BOOT = 'STATE_BOOT';
export const STATE_LOAD = 'STATE_LOAD';
export const STATE_WELCOME = 'STATE_WELCOME';
export const STATE_CAMPOUT = 'STATE_CAMPOUT';

export const STATE_MAP = {
  STATE_BOOT: StateBoot,
  STATE_LOAD: StateLoad,
  STATE_WELCOME: StateWelcome,
  STATE_CAMPOUT: StateCampout,
};
